module.exports = __webpack_public_path__ + "static/media/uiuxdesign.d067aaf8.svg";